/**
 * Mobile features module
 */

import { isPhone } from './phone.js';

export function setupMobileFeatures() {
    if ('ontouchstart' in window) {
        document.body.classList.add('touch-device');
    }
    setViewportHeight();
    window.addEventListener('resize', () => setViewportHeight(), { passive: true });
}

export function setViewportHeight() {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
}

export function setupResponsiveTables() {
    const tables = document.querySelectorAll('.responsive-table');
    tables.forEach(table => {
        if (isPhone()) {
            makeTableResponsive(table);
        }
    });
}

function makeTableResponsive(table) {
    const headers = Array.from(table.querySelectorAll('th')).map(th => th.textContent.trim());
    const rows = table.querySelectorAll('tbody tr');

    rows.forEach(row => {
        const cells = row.querySelectorAll('td');
        cells.forEach((cell, index) => {
            if (headers[index]) {
                cell.setAttribute('data-label', headers[index]);
            }
        });
    });
}
